import React from "react";
import "../../InvoiceModal.css";
import { capitalize } from "../../../../helpers/helpers";
import { useTranslation } from "react-i18next";

const International = ({ data }) => {
  const { t } = useTranslation("finances");
  const intl = data?.international;
  if (intl === null || intl?.length === 0) return null;

  const isMulti = Array.isArray(intl?.products);

  if (isMulti) {
    const summary = intl.products.reduce(
      (acc, product) => {
        const count = Number(product?.Count || 0);
        const price = Number(product?.TotalPriceAmount || 0);
        const declared = Number((count * price).toFixed(2));

        // add per-product declared value
        product.DeclaredValue = declared;

        acc.totalUnits += count;
        acc.totalDeclared += declared;

        return acc;
      },
      { totalUnits: 0, totalDeclared: 0 },
    );

    intl.totalUnits = summary.totalUnits;
    intl.totalDeclared = Number(summary.totalDeclared.toFixed(2));
  }

  const renderProducerInfo = () => (
    <div className="invmodal__shipment_summaryfrom">
      <div className="invmodal__shipment_sumitemhding">
        {t("invoice.international.producerInfo")}
      </div>

      <div className="invmodal__shipment_sumitem">
        <div className="invmodal__international_sumitemleft">
          {t("invoice.international.companyName")}
        </div>
        <div className="invmodal__shipment_sumitemright">
          {intl?.producer?.CompanyName ?? "-"}
        </div>
      </div>

      <div className="invmodal__shipment_sumitem">
        <div className="invmodal__international_sumitemleft">
          {t("invoice.international.country")}
        </div>
        <div className="invmodal__shipment_sumitemright">
          {intl?.producer?.Country ?? "-"}
        </div>
      </div>
    </div>
  );

  const renderDuties = () =>
    intl?.duties_by
      ? t(`invoice.international.payer.${intl.duties_by}`, {
          defaultValue: capitalize(intl.duties_by),
        })
      : t("invoice.international.payer.receiver");

  return (
    <>
      {/* ---------- MULTIPLE PRODUCTS ---------- */}
      {isMulti ? (
        <>
          <div className="invmodal__shipment_details">
            <div className="invmodal__shipment_summaryhding internation__declaration_header">
              {t("invoice.international.summaryTitle")}
            </div>

            <div className="invmodal__shipment_detailshding">
              {t("invoice.international.declaredProducts")}
            </div>

            <table className="invmodal__shdetails_table">
              <thead>
                <tr>
                  <th className="invmodal__shdetails_tablehd">#</th>
                  <th className="invmodal__shdetails_tablehd">
                    {t("invoice.international.units")}
                  </th>
                  <th className="invmodal__shdetails_tablehd">
                    {t("invoice.international.description")}
                  </th>
                  <th className="invmodal__shdetails_tablehd">
                    {t("invoice.international.commodityCode")}
                  </th>
                  <th className="invmodal__shdetails_tablehd">
                    {t("invoice.international.country")}
                  </th>
                  <th className="invmodal__shdetails_tablehd">
                    {t("invoice.international.unitValue")}
                  </th>
                  <th className="invmodal__shdetails_tablehd">
                    {t("invoice.international.totalDeclaredValue")}
                  </th>
                </tr>
              </thead>

              <tbody>
                {intl.products.map((p, index) => (
                  <tr key={index}>
                    <td className="invmodal__shdetails_tableitem">
                      {index + 1}
                    </td>
                    <td className="invmodal__shdetails_tableitem">
                      {p?.Count}
                    </td>
                    <td className="invmodal__shdetails_tableitem">
                      {p?.Description}
                    </td>
                    <td className="invmodal__shdetails_tableitem">
                      {p?.CommodityCode}
                    </td>
                    <td className="invmodal__shdetails_tableitem">
                      {p?.Country}
                    </td>
                    <td className="invmodal__shdetails_tableitem">
                      {p?.TotalPriceAmount}
                    </td>
                    <td className="invmodal__shdetails_tableitem">
                      {p?.TotalPriceAmount} x {p?.Count} = {p?.DeclaredValue}{" "}
                      CAD
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="invmodal__shipment_summary">
            <div className="invmodal__shipment_summarycntnt">
              {renderProducerInfo()}

              <div className="invmodal__shipment_summaryto">
                <div className="invmodal__shipment_sumitemhding">
                  {t("invoice.international.additionalInfo")}
                </div>

                <div className="invmodal__shipment_sumitem">
                  <div className="invmodal__international_sumitemleft">
                    {t("invoice.international.insuranceAmount")}
                  </div>
                  <div className="invmodal__shipment_sumitemright">
                    {intl?.InsuranceAmount ?? "-"}
                  </div>
                </div>

                <div className="invmodal__shipment_sumitem">
                  <div className="invmodal__international_sumitemleft">
                    {t("invoice.international.reasonForExport")}
                  </div>
                  <div className="invmodal__shipment_sumitemright">
                    {intl?.ReasonForExport ?? "-"}
                  </div>
                </div>

                <div className="invmodal__shipment_sumitem">
                  <div className="invmodal__international_sumitemleft">
                    {t("invoice.international.totalDeclaredUnits")}
                  </div>
                  <div className="invmodal__shipment_sumitemright">
                    {intl?.totalUnits}
                  </div>
                </div>

                <div className="invmodal__shipment_sumitem">
                  <div className="invmodal__international_sumitemleft">
                    {t("invoice.international.totalDeclaredValue")}
                  </div>
                  <div className="invmodal__shipment_sumitemright">
                    {intl?.totalDeclared} CAD
                  </div>
                </div>

                <div className="invmodal__shipment_sumitem">
                  <div className="invmodal__international_sumitemleft">
                    {t("invoice.international.dutiesBy")}
                  </div>
                  <div className="invmodal__shipment_sumitemright">
                    {renderDuties()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        /* ---------- SINGLE PRODUCT ---------- */
        <div className="invmodal__shipment_summary">
          <div className="invmodal__shipment_summaryhding internation__declaration_header">
            {t("invoice.international.summaryTitle")}
          </div>

          <div className="invmodal__shipment_summarycntnt">
            <div className="invmodal__shipment_summaryto">
              <div className="invmodal__shipment_sumitemhding">
                {t("invoice.international.productInfo")}
              </div>

              {[
                "Description",
                "Country",
                "InsuranceAmount",
                "ReasonForExport",
                "TotalPriceAmount",
              ].map((key) => (
                <div className="invmodal__shipment_sumitem" key={key}>
                  <div className="invmodal__international_sumitemleft">
                    {t(`invoice.international.fields.${key}`)}
                  </div>
                  <div className="invmodal__shipment_sumitemright">
                    {intl?.product?.[key] ?? "-"}
                  </div>
                </div>
              ))}

              <div className="invmodal__shipment_sumitem">
                <div className="invmodal__international_sumitemleft">
                  {t("invoice.international.dutiesBy")}
                </div>
                <div className="invmodal__shipment_sumitemright">
                  {renderDuties()}
                </div>
              </div>
            </div>

            {renderProducerInfo()}
          </div>
        </div>
      )}
    </>
  );
};

export default International;
